import { useState } from 'react';
import { api } from '../../../api/client';
import { useAction } from '../../../api/hooks';
import { Button } from '../../../ui/Button';
import { ErrorAlert } from '../../../ui/feedback';
import { Field, Select, Textarea } from '../../../ui/forms';
import { Modal } from '../../../ui/Modal';
import type { ImplDetail } from './types';

export function ExceptionDialog({
  i,
  onClose,
  inv,
}: {
  i: ImplDetail;
  onClose: () => void;
  inv: unknown[][];
}) {
  const tests = i.evidence?.tests.filter((t) => t.result !== 'passed').map((t) => t.name) ?? [];
  const [testName, setTestName] = useState(tests[0] ?? '*');
  const [reason, setReason] = useState('');
  const m = useAction(
    () =>
      api.post(`/projects/${i.project.key}/tickets/${i.ticket.number}/implementation/exceptions`, {
        testName,
        reason,
      }),
    { success: 'Exception approved', invalidate: inv as never, onSuccess: onClose },
  );
  return (
    <Modal
      title="Approve readiness exception"
      onClose={onClose}
      actions={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={() => m.mutate(undefined)} loading={m.isPending} disabled={!reason.trim()}>
            Approve exception
          </Button>
        </>
      }
    >
      <p className="muted">
        Expected checks that could not run need your explicit exception. It is recorded under your name and
        shown on release review.
      </p>
      <Field label="Check">
        {(p) => (
          <Select {...p} value={testName} onChange={(e) => setTestName(e.target.value)}>
            {tests.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
            <option value="*">No tests could run at all</option>
          </Select>
        )}
      </Field>
      <Field label="Reason">
        {(p) => <Textarea {...p} rows={3} value={reason} onChange={(e) => setReason(e.target.value)} />}
      </Field>
      <ErrorAlert error={m.error} />
    </Modal>
  );
}
